import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

import { zoomHitFix } from './zoomHitFix.js';

// Register once; importing this module is the side effect.
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  BarElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend,
  // Ohne das globale html { zoom: 0.9 } trifft der Zeiger sonst nach rechts
  // hin zunehmend den falschen Datenpunkt.
  zoomHitFix,
);

// Custom tooltip positioner: the tooltip follows the mouse cursor inside the chart.
if (Tooltip.positioners && !Tooltip.positioners.cursor) {
  Tooltip.positioners.cursor = (_items, eventPosition) => eventPosition;
}
